import withVistaDatosSesion from "../../hoc/Docentes/withVistaDatosSesion";
import VistaDatosSesion from "../../view/components/RegistroUsuarios/DatosSesion/VistaDatosSesion";

export default withVistaDatosSesion(VistaDatosSesion);